(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-blocks"] && !Shopify.designMode) return;
  try {
    
      const blocks = document.querySelectorAll('.campaign-block');
      blocks.forEach(block => {
        if(block.querySelector('.question-icon')){
            let element = block.querySelector('.question-icon');
            const infoBox = block.querySelector('.campaign_info');
            if(window.innerWidth < 750){
                element.onclick = function(){
                    document.querySelectorAll('.campaign_info').forEach(function(info){
                if(info != infoBox){
                  if(info.classList.contains('open')){ info.classList.remove('open'); info.style.display = 'none'; }
                }
              });
              if(infoBox.classList.contains('open')){
                infoBox.style.display = 'none';
                infoBox.classList.remove('open');
              } else {
                infoBox.style.display = 'block';
                infoBox.classList.add('open');
              }
            }
          }
          else{
            element.onmouseover = function(){
              infoBox.style.display = 'block';
            }
            element.onmouseout = function(){
              infoBox.style.display = 'none';
            }
          }
        }
      });

      document.addEventListener('click', function(e){
        let el = e.target;
        if(!el.classList.contains('question-icon')) {
          if(document.querySelector('.campaign_info.open')){
            document.querySelector('.campaign_info.open').style.display = 'none';
            document.querySelector('.campaign_info.open').classList.remove('open');
          }
        }
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_animated-media"] && !Shopify.designMode) return;
  try {
    
  class ScrollSlider extends window.HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector("[data-config]");
      this.config = this.slider.dataset.config;
      this.speed = Number(this.slider.dataset.speed) || 60;
      this.sliderItems = this.querySelectorAll(".tm-item");
      this.sliderWidth = 0;

      // Calculate total width of slider items
      this.sliderItems.forEach(item => {
        this.sliderWidth += item.clientWidth;
      });

      this.sliderWidth = this.clientWidth - this.sliderWidth;
      // Initialize GSAP timeline
      this.tm = gsap.timeline();
      this.init();
    }

    init() {
      this.tm.to(this.slider, {
        x: "-100%",
        duration: this.speed,
        ease: "power1.in", // GSAP easing function
        repeat: -1,
        modifiers: {
          x: gsap.utils.unitize(t => parseFloat(t) % window.innerWidth) // use gsap.utils
        },
        onComplete: () => {
          const rect = this.getBoundingClientRect();
          console.log(rect);
        }
      });

      this.addEventListener("mouseenter", () => {
        this.tm.pause();
      });

      this.addEventListener("mouseleave", () => {
        this.tm.play();
      });
    }

    // New method to update speed
    setSpeed(newSpeed) {
      this.speed = newSpeed;
      this.tm.timeScale(newSpeed / 60); // Adjust the timeline speed
    }

    // New method to reset the slider
    resetSlider() {
      this.tm.restart();
    }
  }

  // Define the custom element
  if (!window.customElements.get("scroll-slider")) {
    window.customElements.define("scroll-slider", ScrollSlider);
  }


  document.addEventListener("DOMContentLoaded", function() {
    // Initialize the tooltip

    // Add event listener for window resize
    window.addEventListener("resize", function() {
      // Re-initialize the tooltip on resize
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_benefit-box-content"] && !Shopify.designMode) return;
  try {
    
  function initTooltip() {
    const tooltip = document.querySelectorAll('[data-js-tooltip]');
    const tooltipMobile = document.querySelectorAll('[data-js-tooltip-mobile]');
    let tooltipVisible = false; // Flag to track tooltip visibility

    if (tooltip || tooltipMobile) {
      // Use click event for mobile
      tooltipMobile.forEach(function(tooltip) {
        tooltip.addEventListener('click', function() {
          console.log('click');
          const content = tooltip.closest('[data-js-tooltip-container]').querySelector('[data-js-tooltip-content]');
          tooltipVisible = !tooltipVisible; // Toggle the flag
          content.classList.toggle('cust-benefit-box-content__info-box--visible', tooltipVisible);

          // Add event listener for click the box
          content.addEventListener('click', function() {
            tooltipVisible = false; // Reset the flag
            content.classList.remove('cust-benefit-box-content__info-box--visible');
          });
        });
      });

      // Use mouseover/mouseout for desktop
      tooltip.forEach(function(tooltip) {
        tooltip.addEventListener('mouseover', function() {
          console.log('mouseover');
          const content = tooltip.closest('[data-js-tooltip-container]').querySelector('[data-js-tooltip-content]');
          content.classList.add('cust-benefit-box-content__info-box--visible');
        });
        tooltip.addEventListener('mouseout', function() {
          console.log('mouseout');
          const content = tooltip.closest('[data-js-tooltip-container]').querySelector('[data-js-tooltip-content]');
          content.classList.remove('cust-benefit-box-content__info-box--visible');
        });
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function() {
    // Initialize the tooltip
    initTooltip();

    // Add event listener for window resize
    window.addEventListener("resize", function() {
      // Re-initialize the tooltip on resize
      initTooltip();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_faq-with-image"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('[data-item]');
    items.forEach(item => {
      item.addEventListener('click', function() {
        this.classList.toggle('active');
        items.forEach(otherItem => {
          if (otherItem !== this) {
            otherItem.classList.remove('active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m11-bf-grid-section"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(){
        const btn = document.querySelector('.m11-bf-grid__btn');
        const wrapper = document.querySelector('.m11-bf-grid__popup');
        const closeIcon = document.querySelector('.m11-bf-grid__popup .close-icon');
        btn.addEventListener('click', function(){
            wrapper.style.display = 'block';
        });
        closeIcon.addEventListener('click', function(){
            wrapper.style.display = 'none';
        });
        window.addEventListener('click', function(e){
            if(e.target === wrapper && e.target != document.querySelector('.m9-icon-with-popup-inner')){
                wrapper.style.display = 'none';
            }
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-compare-table"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        if(document.querySelector('.pdp-compare-table-block-subscribe-popup-button')){
            const popupButton = document.querySelector('.pdp-compare-table-block-subscribe-popup-button');
            const popupButtonWrapper = document.querySelector('.pdp-subscribe-popup-container');
            const popupCloseButton = document.querySelector('.pdp-subscribe-popup-close-button');

            popupButton.addEventListener('click', function() {
                popupButtonWrapper.style.display = 'block';
                document.body.classList.add('overflow-hidden');
            });

            popupCloseButton.addEventListener('click', function() {
                popupButtonWrapper.style.display = 'none';
                document.body.classList.remove('overflow-hidden');
            });

            popupButtonWrapper.addEventListener('click', function(e) {
                if(!e.target.classList.contains('pdp-subscribe-popup-content') && !e.target.closest('.pdp-subscribe-popup-content')){
                popupButtonWrapper.style.display = 'none';
                document.body.classList.remove('overflow-hidden');
                }
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-button"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const popupButton = document.querySelector('.popup-button-link');
    const popupButtonWrapper = document.querySelector('.popup-button-wrapper');
    const popupCloseButton = document.querySelector('.popup-close-button');

    popupButton.addEventListener('click', function() {
      popupButtonWrapper.style.display = 'block';
      document.body.classList.add('overflow-hidden');
    });

    popupCloseButton.addEventListener('click', function() {
      popupButtonWrapper.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
    });

    popupButtonWrapper.addEventListener('click', function(e) {
      if(!e.target.classList.contains('popup-button-popup-content') && !e.target.closest('.popup-button-popup-content')){
        popupButtonWrapper.style.display = 'none';
        document.body.classList.remove('overflow-hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-collection-testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  function adjustArrows(){
    if(document.querySelector('.pps-collection-testimonial-text-slider .flickity-button.previous').hasAttribute('disabled')){
      document.querySelector('.pps-collection-testimonial-text-slider-wrap .slider-button-prev').setAttribute('disabled','');
    }
    else{
      document.querySelector('.pps-collection-testimonial-text-slider-wrap .slider-button-prev').removeAttribute('disabled');
    }

    if(document.querySelector('.pps-collection-testimonial-text-slider .flickity-button.next').hasAttribute('disabled')){
      document.querySelector('.pps-collection-testimonial-text-slider-wrap .slider-button-next').setAttribute('disabled','');
    }
    else{
      document.querySelector('.pps-collection-testimonial-text-slider-wrap .slider-button-next').removeAttribute('disabled');
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    if(window.innerWidth > 749){
      var flkty_main = new Flickity( '.pps-collection-testimonial-text-slider', {
        prevNextButtons: true,
        pageDots: false,
        watchCSS: true
      });

      document.querySelector('.pps-collection-testimonial-text-slider-wrap .slider-button-prev').onclick = function(){
        document.querySelector('.pps-collection-testimonial-text-slider .flickity-button.previous').click();
        adjustArrows();
      }

      document.querySelector('.pps-collection-testimonial-text-slider-wrap .slider-button-next').onclick = function(){
        document.querySelector('.pps-collection-testimonial-text-slider .flickity-button.next').click();
        adjustArrows();
      }

      var flkty = new Flickity( '.pps-collection-testimonial-nav-slider', {
        prevNextButtons: false,
        pageDots: true,
        contain: true,
        wrapAround: true,
        watchCSS: true,
        asNavFor: '.pps-collection-testimonial-text-slider',
        adaptiveHeight: true,
        setGallerySize: false
      });

      flkty.on('ready', function() {
        flkty.reposition();
      });

      flkty.on('change', function(event, index) {
        document.querySelector('.pps-collection-testimonial-nav-slider').classList.add('slide-changed');
        flkty.reposition();
        flkty_main.select(flkty.selectedIndex)
      });
      flkty_main.on('change', function(event, index) {
        flkty.select(flkty_main.selectedIndex)
      });
    }
    else{
      var swiper = new Swiper(".pps-collection-testimonial-nav-swiper", {
        spaceBetween: 0,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        centeredSlides: false,
        breakpoints: {
          749: {
            centeredSlides: true,
            loopAdditionalSlides: 30,
          }
        }
      });
       // thumbs: {
       //    swiper: swiper
       //  },
      var swiper2 = new Swiper(".pps-collection-testimonial-text-swiper", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        navigation: {
          nextEl: ".pps-collection-testimonial-text-swiper .swiper-button-next",
          prevEl: ".pps-collection-testimonial-text-swiper .swiper-button-prev",
        },

        scrollbar: {
            el: '.pps-collection-testimonial .swiper-scrollbar',
            draggable: true
        }
      });
      swiper.on('slideChange', () => {
        swiper2.slideTo(swiper.activeIndex);
      });

      swiper2.on('slideChange', () => {
        swiper.slideTo(swiper2.activeIndex);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-users-with-indication"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
        let swiperEl = document.querySelector('.pps-users-section .swiper');
        new Swiper(swiperEl, {
            slidesPerView: 'auto',
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            spaceBetween: 20,
            scrollbar: {
                el: '.pps-users-section .swiper-scrollbar',
                draggable: true
            }
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-collection-products"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        if(window.innerWidth < 749){
            if(document.querySelectorAll('.sg-products-section .sg-products-swiper').length > 0){
                document.querySelectorAll('.sg-products-section .sg-products-swiper').forEach(function(swiper){
                    var swiper = new Swiper(swiper, {
                        slidesPerView: 'auto',
                        pagination: {
                            el: swiper.parentElement.querySelector(".swiper-pagination")
                        },
                    });
                });
            }
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-campaign-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelector('.slider-campaign-terms-popup')) {
      const termsText = document.querySelector('.slider-campaign-section .terms-text');
      const termsPopup = document.querySelector('.slider-campaign-terms-popup');
      const termsPopupClose = document.querySelector('.slider-campaign-terms-popup-close');
      if (termsText) {
        termsText.addEventListener('click', function() {
          termsPopup.style.display = 'block';
        });
      }
      termsPopupClose.addEventListener('click', function() {
        termsPopup.style.display = 'none';
      });
      termsPopup.addEventListener('click', function(e) {
        if (e.target != document.querySelector('.slider-campaign-terms-popup-inner') && !e.target.closest('.slider-campaign-terms-popup-inner')) {
          termsPopup.style.display = 'none';
        }
      });
    }

    if(document.querySelector('[data-subscribe-popup-btn]')) {
      const subscribePopupBtn = document.querySelector('[data-subscribe-popup-btn]');
      subscribePopupBtn.addEventListener('click', function() {
        if(document.querySelector('.email-subscription-popup__trigger-image-wrapper'))
          document.querySelector('.email-subscription-popup__trigger-image-wrapper').click();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-multiple"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelectorAll('.popup-button-link').length > 0){
        const popupButton = document.querySelector('.popup-button-link');
        const popupButtonWrapper = document.querySelector('.popup-button-wrapper.star-multiple-popup-button-wrapper');
        const popupCloseButton = document.querySelector('.popup-close-button');

        if(!popupButtonWrapper) return;
        popupButton.addEventListener('click', function() {
          popupButtonWrapper.style.display = 'block';
          document.body.classList.add('overflow-hidden');
        });

        popupCloseButton.addEventListener('click', function() {
          popupButtonWrapper.style.display = 'none';
          document.body.classList.remove('overflow-hidden');
        });

        popupButtonWrapper.addEventListener('click', function(e) {
          if(!e.target.classList.contains('popup-button-popup-content') && !e.target.closest('.popup-button-popup-content')){
            popupButtonWrapper.style.display = 'none';
            document.body.classList.remove('overflow-hidden');
          }
        });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-page-title"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sectionRoot = document.querySelector('.star-page-title-section');

    if (!sectionRoot) {
      return;
    }

    var sectionWrapper = sectionRoot.parentElement;
    const popupButton = sectionRoot.querySelector('.popup-button-link');
    const popupButtonWrapper = sectionWrapper ? sectionWrapper.querySelector('.popup-button-wrapper') : null;
    const popupCloseButton = popupButtonWrapper ? popupButtonWrapper.querySelector('.popup-close-button') : null;

    const handlePopupOpen = function() {
      popupButtonWrapper.style.display = 'block';
      document.body.classList.add('overflow-hidden');
    };

    const handlePopupClose = function() {
      popupButtonWrapper.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
    };

    const handlePopupWrapperClick = function(e) {
      if (!e.target.classList.contains('popup-button-popup-content') && !e.target.closest('.popup-button-popup-content')) {
        handlePopupClose();
      }
    };

    if (popupButton && popupButtonWrapper && popupCloseButton) {
      popupButton.addEventListener('click', handlePopupOpen);
      popupCloseButton.addEventListener('click', handlePopupClose);
      popupButtonWrapper.addEventListener('click', handlePopupWrapperClick);
    }

    document.querySelectorAll('[data-pw-free-ecoflow-client-check="1"]').forEach(function (root) {
      var hasSession = (function () {
        if (typeof getCookie !== 'function') return false;
        var raw = getCookie('userInfo');
        if (!raw) return false;
        try {
          var parsed = JSON.parse(decodeURIComponent(raw));
          return !!(parsed && parsed.token && String(parsed.token).length > 0);
        } catch (e) { return false; }
      })();

      if (hasSession) {
        root.querySelectorAll('[data-open-password-free-login-popup]').forEach(function (btn) {
          var msg = btn.getAttribute('data-password-free-success-message');
          if (msg && msg.trim()) {
            btn.textContent = msg.trim();
            btn.classList.add('password-free-button-link--logged-in');
          }
          btn.removeAttribute('data-open-password-free-login-popup');
        });
      }
    });

    document.addEventListener('shopify:section:unload', function() {
      if (popupButton && popupButtonWrapper && popupCloseButton) {
        popupButton.removeEventListener('click', handlePopupOpen);
        popupCloseButton.removeEventListener('click', handlePopupClose);
        popupButtonWrapper.removeEventListener('click', handlePopupWrapperClick);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function initializeTestimonialSwiper() {
      var swiperContainer = document.querySelector('.testimonial-slider__block-container--swiper');
      var blockWrapperCount = document.querySelectorAll('.testimonial-slider__block-wrapper').length;

      if (swiperContainer.classList.contains('swiper-initialized')) {
        var existingSwiper = swiperContainer.swiper;
        if (existingSwiper) {
          existingSwiper.destroy();
        }
        swiperContainer.classList.remove('swiper-initialized');
      }

        var swiper = new Swiper(swiperContainer, {
          freeMode: true,
          spaceBetween: 20,
          slidesPerView: 1.19,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            600: {
              slidesPerView: 2.19,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 27,
            },
          },
        });

        swiperContainer.swiper = swiper;
        swiperContainer.classList.add('swiper-initialized');

    }

    initializeTestimonialSwiper();

    window.addEventListener('resize', function () {
      initializeTestimonialSwiper();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
